"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 20",
    width: "24",
    height: "20"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21,4V2.5C21,1.1,19.9,0,18.5,0h-16C1.1,0,0,1.1,0,2.5V4h20.5H21z M3.5,3C3.2,3,3,2.8,3,2.5S3.2,2,3.5,2 C3.8,2,4,2.2,4,2.5S3.8,3,3.5,3z M5.5,3C5.2,3,5,2.8,5,2.5S5.2,2,5.5,2C5.8,2,6,2.2,6,2.5S5.8,3,5.5,3z M7.5,3C7.2,3,7,2.8,7,2.5 S7.2,2,7.5,2C7.8,2,8,2.2,8,2.5S7.8,3,7.5,3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21,13.5V5h-0.5H0v8.5C0,14.9,1.1,16,2.5,16h16C19.9,16,21,14.9,21,13.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22,9v4.5c0,1.9-1.6,3.5-3.5,3.5H3v0.5C3,18.9,4.1,20,5.5,20h16c1.4,0,2.5-1.1,2.5-2.5V9H22z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,8V6.5c0-1.2-0.9-2.2-2-2.4V8H24z"
  }));
};

exports["default"] = _default;